import styled from 'styled-components';

import { Button } from '@savgroup-front-common/core/atoms/button';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $DocumentWrapper = styled.div`
  container: documentCard / inline-size;
  border: 1px solid ${({ theme }) => theme.colors.default};
  padding: ${spacing('lg')};
  border-radius: ${({ theme }) => theme.tw.radius.sm};
  flex: 1;
  color: ${({ theme }) => theme.systemColors.defaultTextColor};
  ${fontStyle('lg')};
  font-weight: ${fontWeight('medium')};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing('sm')};
`;

export const $DocumentContent = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
`;

export const $DocumentIcon = styled.div`
  width: ${spacing('xxl')};
  height: ${spacing('xxl')};
  margin-right: ${spacing('lg')};
  flex-shrink: 0;

  && svg {
    max-width: 100%;
    max-height: 100%;
  }
`;

export const $DocumentName = styled.div`
  display: block;
  flex: 1;
  min-width: 0;
  margin-right: ${spacing(5)};
  ${fontStyle('base')};
  color: ${({ theme }) => theme.colors.mainTextColor};
`;

export const $DocumentNameTitle = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const $DocumentNameDescription = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${fontStyle('sm')};
  font-weight: ${fontWeight('normal')};
  color: ${({ theme }) => theme.colors.paragraphTextColor};
`;

export const $DocumentButton = styled(Button)`
  && {
    flex-shrink: 0;
    text-align: left;
    line-height: 1.1rem;
    min-width: unset;
    max-width: fit-content;
    white-space: nowrap;

    & span {
      align-items: flex-end;
      width: auto;
    }

    && svg {
      margin-right: ${spacing('xs')};
      width: ${spacing(5)};
    }
  }

  @container documentCard (max-width: 400px) {
    && {
      & .children {
        display: none;
      }

      && svg {
        margin-right: 0;
      }
    }
  }
`;
